import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

type DashboardButtonProps = {
  text: string;
  link: string;
  "data-test-id"?: string;
};

const DashboardButton = (props: DashboardButtonProps) => {
  const navigate = useNavigate();
  return (
    <div
      className="cpl-btn cpl-btn-primary rounded d-flex justify-content-center align-items-center"
      style={{ height: "40px" }}
      onClick={() => navigate(props.link)}
      data-test-id={props["data-test-id"]}
    >
      <span className="me-2">{props.text}</span>
      <FontAwesomeIcon icon={faChevronRight} />
    </div>
  );
};

export default DashboardButton;
